// extracted by mini-css-extract-plugin
export default {"link":"StorePurchaseReport_link__BSvKx","no_hover":"StorePurchaseReport_no_hover__XtCNM"};